import classNames from 'classnames';
import { debounce } from 'lodash';
import { ChangeEvent, ReactNode } from 'react';

import { Form, Spinner } from '../../../bootstrap';
import { ButtonLink } from '../Button/ButtonLink';

export const TableSearchAndButtons = ({
  searchPlaceholder,
  setSearchQuery,
  canSearch = true,
  customSearchElement,
  controls,
  className,
  ColumnPickerElement,
  isLoading,
  resetFilters,
  isFiltered,
}: {
  searchPlaceholder: string;
  setSearchQuery: (s: string) => void;
  canSearch?: boolean;
  customSearchElement?: ReactNode;
  controls?: ReactNode;
  className?: string;
  ColumnPickerElement?: ReactNode;
  isLoading?: boolean;
  resetFilters?: () => void;
  isFiltered?: boolean;
}) => {
  const handleSetSearchQuery = debounce((e: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  }, 500);

  return (
    <div className={classNames(className, 'd-flex justify-content-between')}>
      <div className="u-flex-1 d-flex gap-4">
        {customSearchElement ||
          (canSearch && (
            <Form.Control
              className="w-100 u-maxw-3"
              size="sm"
              type="text"
              placeholder={searchPlaceholder}
              onChange={handleSetSearchQuery}
            />
          ))}
        {ColumnPickerElement}
        {resetFilters && isFiltered && (
          <ButtonLink variant="primary" onClick={resetFilters}>
            Reset Filters
          </ButtonLink>
        )}
      </div>

      <div className="d-flex gap-2">
        {isLoading && (
          <div className="d-flex gap-2 align-items-center me-2">
            Updating results <Spinner size="sm" className="u-color-pine3" />
          </div>
        )}
        {controls}
      </div>
    </div>
  );
};
